/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The styled components for MoneyTransfer page
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.4.0
 * @since 1.2.0
 */

import styled from 'styled-components';

import { colors, fonts, globalThemeConstants } from '../../../../theme';

export const MoneyTransferFirstStepContainerStyled = styled.div`
    margin-top: 32px;
`;

export const MoneyTransferFirstStepParamsContainerStyled = styled.div`
    width: 590px;
`;

export const MoneyTransferAmountContainerStyled = styled.div`
    width: 285px;
`;

interface IMoneyTransferHintStyled {
    isValid?: boolean;
}

export const MoneyTransferHintStyled = styled.div<IMoneyTransferHintStyled>`
    margin-top: 4px;
    white-space: nowrap;
    ${fonts.textSmall}
    color: ${props => props.isValid !== undefined && !props.isValid ?
    colors.wizardHintValidationColorError : colors.wizardHintValidationColorDefault};
`;

export const MoneyTransferConflictItemStyled = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 16px;

    .icon {
        padding-left: 4px;
        margin-right: ${globalThemeConstants.gutter}px;
    }
`;

export const MoneyTransferFinalStepContainerStyled = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 32px;
`;
